import React from 'react'
import CivilContent from '../../AllPageContent/AllPageContent'

const LessonNotes = ({ paragraphs }) => {
  return (
      <>
          <div className='p-4'>
              <div className='card classquestion-card px-5 py-4'>
                  <CivilContent paragraphs={paragraphs} />
              </div>
          </div>
      </>
  )
}

export default LessonNotes